import axios from "axios";

const GetRequest = async (param, setData, url, headers) => {
  try {
    return await axios
      .get(url + "/" + param, {
        headers: headers,
      })
      .then((response) => {
        if (setData !== null) {
          setData(response.data);
        }
        return response;
      });
  } catch (err) {
    throw err;
  }
};

export { GetRequest };
